import { queryOptions } from "@tanstack/react-query";
import fetcher from "@/core/lib/fetcher";
import type { APIResponse } from "@/core/types/utils";
import type { EventFormValues, EventItem } from "./events.types";

export const getEvents = (siteId: string, token: string) =>
	queryOptions({
		queryKey: ["events", siteId, token],
		queryFn: () =>
			fetcher
				.auth(`Bearer ${token}`)
				.get(import.meta.env.VITE_API_BOOKING + `property/${siteId}/events`)
				.json<APIResponse<EventItem[]>>(),
	});

export const getEventById = (siteId: string, token: string, eventId: string) =>
	queryOptions({
		queryKey: ["event", siteId, token, eventId],
		queryFn: () =>
			fetcher
				.auth(`Bearer ${token}`)
				.get(
					import.meta.env.VITE_API_BOOKING +
						`property/${siteId}/events/${eventId}`,
				)
				.json<APIResponse<EventItem>>(),
	});

export const createEvent = (
	data: EventFormValues,
	siteId: string,
	token: string,
) =>
	fetcher
		.auth(`Bearer ${token}`)
		.url(import.meta.env.VITE_API_BOOKING + `property/${siteId}/events`)
		.post(data)
		.json<APIResponse<EventItem>>();

export const updateEvent = (
	data: EventFormValues,
	siteId: string,
	token: string,
	eventId: string,
) =>
	fetcher
		.auth(`Bearer ${token}`)
		.url(
			import.meta.env.VITE_API_BOOKING + `property/${siteId}/events/${eventId}`,
		)
		.put(data)
		.json<APIResponse<EventItem>>();

export const archiveEvent = (siteId: string, token: string, eventId: string) =>
	fetcher
		.auth(`Bearer ${token}`)
		.url(
			import.meta.env.VITE_API_BOOKING + `property/${siteId}/events/${eventId}`,
		)
		.delete()
		.json<APIResponse<null>>();
